__turbopack_context__.v({
  "borderGradient": "UIButton-module__fHYOdW__borderGradient",
  "rotate-border": "UIButton-module__fHYOdW__rotate-border",
});
